/** @hidden */
var WebGPUDrawContext =
/** @class */
function () {
  function WebGPUDrawContext() {
    this.fastBindGroups = {};
    this.uniqueId = WebGPUDrawContext._Counter++;
  }

  WebGPUDrawContext._Counter = 0;
  return WebGPUDrawContext;
}();

export { WebGPUDrawContext };